<template>
    <div class="p-4 ds-exchange-panel-content">
        <div class="flex items-start mb-2 pr-10">
            <div class="ds-exchange-panel-title min-w-0 flex-1 mr-3">Вакансия "{{ position.name }}"</div>
            <VacancyStatus :status="vacancy.status" class="shrink-0" />
        </div>
        <div class="ds-exchange-panel-section border-grayxlight border-b mb-2">Основные данные</div>

        <div class="flex mb-3">
            <div class="flex-1">
                <div class="ds-exchange-field-label">Должность</div>
                <div class="ds-exchange-detail-value">{{ position.name }}</div>
            </div>
            <div class="flex-1">
                <div class="ds-exchange-field-label">Время начала</div>
                <div class="ds-exchange-detail-value">{{ start }}</div>
            </div>
        </div>

        <div class="flex mb-3">
            <div class="flex-1">
                <div class="ds-exchange-field-label">Магазин</div>
                <div class="ds-exchange-detail-value">{{ department.name }}</div>
            </div>
            <div class="flex-1">
                <div class="ds-exchange-field-label">Время окончания</div>
                <div class="ds-exchange-detail-value">{{ end }}</div>
            </div>
        </div>

        <div class="flex mb-5">
            <div class="flex-1">
                <div class="ds-exchange-field-label">Дата</div>
                <div class="ds-exchange-detail-value">{{ date }}</div>
            </div>
            <div class="flex-1">
                <div class="ds-exchange-field-label">Ставка</div>
                <div class="ds-exchange-detail-value">{{ price }}</div>
            </div>
        </div>

        <div class="ds-exchange-summary mb-4" v-if="vacancy.assigned_user">
            <div class="ds-exchange-panel-section mb-3">Назначенный</div>
            <div class="flex">
                <Avatar size="md" :first-name="vacancy.assigned_user.first_name" :last-name="vacancy.assigned_user.last_name" :url="vacancy.assigned_user.avatar" />
                <div class="pl-4">
                    <div class="ds-exchange-detail-value">{{ assignedName }}</div>
                    <div class="ds-exchange-field-label">{{ assigned.position.name }}</div>
                    <div class="ds-exchange-field-label">{{ assigned.department.name }}</div>
                </div>
            </div>
        </div>

        <div v-if="skills.length || comment" class="ds-exchange-panel-section border-grayxlight border-b mb-2">Дополнительно</div>

        <Skills :skills v-if="skills.length" />

        <div v-if="comment">
            <div class="ds-exchange-field-label">Комментарий</div>
            <div class="ds-exchange-detail-value">{{ comment }}</div>
        </div>

        <VacancyHistory :vacancy />
    </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { Option } from '../../types'
import dayjs from 'dayjs'
import utc from "dayjs/plugin/utc"
import Skills from './Skills.vue'
import VacancyStatus from './VacancyStatus.vue'
import VacancyHistory from './VacancyHistory.vue'

const { vacancy } = defineProps(['vacancy'])

const emit = defineEmits(['close'])
dayjs.extend(utc)
const date = computed(() => dayjs(vacancy.date).format('DD.MM.YY'))
const start = ref(dayjs(vacancy.dttm_work_start_at).format('HH:mm'))
const end = ref(dayjs(vacancy.dttm_work_end_at).format('HH:mm'))
const comment = ref('')
const position = ref<Option>(vacancy.position)
const department = ref<Option>(vacancy.department)
const price = ref('100')
const skills = ref<any[]>([])
const assigned = computed(() => vacancy.assigned_user)
const assignedName = computed(() => `${assigned.value.first_name} ${assigned.value.last_name}`) 
</script>
